import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Sprite from '~components/Sprite'
import Button from '~components/ui/Button'

class Payment extends Component {
  constructor (props) {
    super(props)

    this.state = {
      busy: false
    }
  }

  render () {
    const url = new URL(window.location.href)
    const paymentStatus = (url.searchParams.get('status') === '1')

    return (
      <div className="fixed z-50 p-4 md:p-8 flex flex-col top-0 left-0 right-0 bottom-0 bg-charcoal bg-opacity-75">
        <div className="bg-white sm:bg-lightGrey w-full m-auto max-w-screen-mdxl px-4 py-8 sm:p-15 sm:pb-0 overflow-scrolling overflow-x-hidden overflow-y-auto relative">
          <button type="button" className="w-10 h-10 absolute top-3 right-1 sm:top-8 sm:right-7 block" aria-label="Close" onClick={this.props.onClose}>
            <span className="w-4 h-4 icon icon-fill block m-auto" aria-hidden="true">
              <Sprite name="cross" />
            </span>
          </button>

          <h3 className="text-md lg:text-2xl border-b border-coral pb-6">
            Payment was
            {paymentStatus ? ' successful' : ' unsuccessful'}
          </h3>

          <div className="mt-12 w-full">
            {paymentStatus ? 'Your payment has been successful and will appear in your invoices as &apos;Paid&apos;.' : 'Your payment has been unsuccessful, please try again.'}
          </div>

          <div className="mt-12 flex flex-wrap -mx-2 sm:bg-white sm:py-8 relative before:bg-white after:bg-white before:-left-max after:-right-max content-after content-before sm:content-before sm:content-after before:absolute after:absolute before:w-max after:w-max before:top-0 after:top-0 before:h-full after:h-full" tw-content-before="" tw-content-after="">
            <div className="w-full px-2 my-2">
              <Button
                theme="green-to-pink"
                className="w-full"
                onClick={this.props.onClose}
              >
                Done
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Payment.propTypes = {
  onClose: PropTypes.func
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(null, mapDispatchToProps)(Payment)
